module.exports = __webpack_public_path__ + "img/stratup-brand-logo-2.94e3f0ad.png";